import * as React from 'react';
import { List } from 'semantic-ui-react';
import { TrackSegmentKind } from '../../../types/fallbackTrackingTypes';
import { SEGMENT_STYLES } from './fallbackTrackingStyles';

const KINDS: TrackSegmentKind[] = ['Real', 'Synthetic', 'NoData'];

const FallbackTrackingLegend: React.FC = () => (
    <List className="fallback-tracking-legend">
        {KINDS.map(kind => {
            const { label, description, strokeColor, strokeThickness } = SEGMENT_STYLES[kind];
            return (
                <List.Item key={kind}>
                    <span className="legend-line" style={{ borderTopColor: strokeColor, borderTopWidth: strokeThickness }} />
                    <span><strong>{label}:</strong> {description}</span>
                </List.Item>
            );
        })}
    </List>
);

export default FallbackTrackingLegend;
